import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '../helpers'
import { Company } from '../models/Company/types'

const QUERY_KEY = ['organizationCompanyList']

const STALE_TIME_MS = 5 * 60 * 1000

export const useOrganizationCompanyList = (
    organizationId: number | null | undefined,
    companyType?: CompanyType,
) => {
    return useQuery<Company[], Error>({
        queryKey: [...QUERY_KEY, organizationId, companyType],
        queryFn: async () => {
            const res = await axiosInstance.get<Company[]>(
                `organization/${organizationId}/company-list/`,
                {
                    params: companyType ? { company_type: companyType } : {},
                },
            )
            return res.data
        },
        enabled: organizationId != null,
        staleTime: STALE_TIME_MS,
        refetchOnWindowFocus: false,
    })
}
